//React
import React from "react";
import PropTypes from "prop-types";
import { Tooltip } from "react-tooltip";
//CSS
import "./index.scss";
import "react-tooltip/dist/react-tooltip.css";

function Audience({ title, value, users, interests, id, currency, exchangeRate }) {
	const formatNumber = (num) => {
		const formatter = Intl.NumberFormat("en-Us", { notation: "compact" });
		return formatter.format(num);
	};

	const currencyFormat = (num) => {
		const formatter = new Intl.NumberFormat("en-US", {
			style: "currency",
			currency: currency,
		});
		return formatter.format(num);
	};

	return (
		<div className="audience">
			<div className="heading-block">
				<h2 className={interests == null ? "no-interests" : "standard"}>
					{title.replaceAll('_', ' ')}
				</h2>
				{interests != null ? (
					<>
						<Tooltip id={`audience-name-${id}`} />
						<p
							className="p4 additional-interests"
							data-tooltip-id={`audience-name-${id}`}
							data-tooltip-content={interests.map((el) => el.text).join(", ")}
						>
							{interests[0].text}
						</p>
					</>
				) : (
					""
				)}
			</div>
			<div className="data">
				<div className="value">
					<div className="value--main">
						<span className="symbol">{currencyFormat(value * exchangeRate).slice(0,1)}</span>
						<span className="num">{currencyFormat(value * exchangeRate).substring(1)}</span>
					</div>
					<p className="p4 info">Prebid CPM</p>
				</div>
				<div className="users">
					<p>
						<span className="p2 strong">{formatNumber(users)}</span>{" "}
						<span className="p2">Unique Users</span>
					</p>
				</div>
			</div>
		</div>
	);
}

Audience.propTypes = {
	title: PropTypes.string.isRequired,
	value: PropTypes.number.isRequired,
	users: PropTypes.number.isRequired,
	interests: PropTypes.array,
	id: PropTypes.string.isRequired,
	currency: PropTypes.string.isRequired,
	exchangeRate: PropTypes.number.isRequired
};

export default Audience;
